import { render, staticRenderFns } from "./IconLeave.vue?vue&type=template&id=3e59bf6d&scoped=true&"
import script from "./IconLeave.vue?vue&type=script&lang=js&"
export * from "./IconLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e59bf6d",
  null
  
)

export default component.exports